import { tv, VariantProps } from "tailwind-variants";

export const buttonStyles = tv({
  base: "inline-block cursor-pointer select-none px-[8px] py-[4px] font-medium outline-hidden focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-solid",
  variants: {
    disabled: {
      true: "cursor-not-allowed opacity-50",
    },
    color: {
      blue: "",
      purple: "",
      white: "",
      lavender: "",
      yellow: "",
      red: "",
      green: "",
    },
    raised: {
      true: "shadow-[0_0_0_1px_var(--faceStroke),0_4px_0_0_var(--offsetFill),0_4px_0_1px_var(--offsetStroke)] hover:not-disabled:shadow-[0_0_0_1px_var(--faceStroke),0_6px_0_0_var(--offsetFill),0_6px_0_1px_var(--offsetStroke)] active:not-disabled:shadow-[0_0_0_1px_var(--faceStroke),0_3px_0_0_var(--offsetFill),0_3px_0_1px_var(--offsetStroke)]",
      false: "shadow-[0_0_0_1px_var(--faceStroke)]",
    },
    outlined: {
      true: "",
      false: "",
    },
    size: {
      big: "rounded-[5px] text-base",
      regular: "rounded-[5px] text-sm",
      small: "rounded-[3px] text-xs",
      tiny: "rounded-[3px] text-2xs",
    },
    font: {
      thin: "font-thin",
      regular: "font-normal",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    disabled: false,
    font: "regular",
  },
  compoundVariants: [
    {
      raised: true,
      className: "duration-75 will-change-transform",
    },
    {
      raised: true,
      disabled: false,
      className: "hover:translate-y-[-2px] active:translate-y-[1px]",
    },
    {
      color: "blue",
      raised: false,
      outlined: false,
      className: "hover:bg-blue-500",
    },
    {
      color: "purple",
      raised: false,
      outlined: false,
      className: "hover:bg-purple-300",
    },
    {
      color: "white",
      raised: false,
      outlined: false,
      className: "hover:bg-white-100",
    },
    {
      color: "lavender",
      raised: false,
      outlined: false,
      className: "hover:bg-lavender-500",
    },
    {
      color: "yellow",
      raised: false,
      outlined: false,
      className: "hover:bg-yellow-500",
    },
    {
      color: "red",
      raised: false,
      outlined: false,
      className: "hover:bg-red-300",
    },
    {
      color: "green",
      raised: false,
      outlined: false,
      className: "hover:bg-green-600",
    },
    {
      color: "blue",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-blue-500)]",
    },
    {
      color: "purple",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-purple-300)]",
    },
    {
      color: "white",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-white-200)]",
    },
    {
      color: "lavender",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-lavender-600)]",
    },
    {
      color: "yellow",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-yellow-400)]",
    },
    {
      color: "red",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-red-500)]",
    },
    {
      color: "green",
      raised: false,
      outlined: true,
      className: "hover:[--faceStroke:var(--color-green-700)]",
    },
    {
      color: "blue",
      outlined: false,
      className:
        "bg-blue-400 text-white-50 [--faceStroke:var(--color-blue-600)] [--offsetFill:var(--color-blue-500)] [--offsetStroke:var(--color-blue-600)]",
    },
    {
      color: "blue",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-blue-400)] [--offsetFill:var(--color-blue-500)] [--offsetStroke:var(--color-blue-400)]",
    },
    {
      color: "purple",
      outlined: false,
      className:
        "bg-purple-200 text-white-50 [--faceStroke:var(--color-purple-500)] [--offsetFill:var(--color-purple-400)] [--offsetStroke:var(--color-purple-500)]",
    },
    {
      color: "purple",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-purple-200)] [--offsetFill:var(--color-purple-400)] [--offsetStroke:var(--color-purple-200)]",
    },
    {
      color: "white",
      outlined: false,
      className:
        "bg-white-50 text-white-900 [--faceStroke:var(--color-white-200)] [--offsetFill:var(--color-white-100)] [--offsetStroke:var(--color-white-200)]",
    },
    {
      color: "white",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-white-50)] [--offsetFill:var(--color-white-100)] [--offsetStroke:var(--color-white-50)]",
    },
    {
      color: "lavender",
      outlined: false,
      className:
        "bg-lavender-500 text-white-100 [--faceStroke:var(--color-lavender-600)] [--offsetFill:var(--color-lavender-800)] [--offsetStroke:var(--color-lavender-800)]",
    },
    {
      color: "lavender",
      outlined: true,
      className:
        "bg-lavender-500 text-white-100 [--faceStroke:var(--color-lavender-400)] [--offsetFill:var(--color-lavender-500)] [--offsetStroke:var(--color-lavender-400)]",
    },
    {
      color: "yellow",
      outlined: false,
      className:
        "bg-yellow-200 text-white-900 [--faceStroke:var(--color-yellow-600)] [--offsetFill:var(--color-yellow-400)] [--offsetStroke:var(--color-yellow-600)]",
    },
    {
      color: "yellow",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-yellow-300)] [--offsetFill:var(--color-yellow-400)] [--offsetStroke:var(--color-yellow-300)]",
    },
    {
      color: "red",
      outlined: false,
      className:
        "bg-red-200 text-white-100 [--faceStroke:var(--color-red-500)] [--offsetFill:var(--color-red-400)] [--offsetStroke:var(--color-red-500)]",
    },
    {
      color: "red",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-red-400)] [--offsetFill:var(--color-red-500)] [--offsetStroke:var(--color-red-400)]",
    },
    {
      color: "green",
      outlined: false,
      className:
        "bg-green-500 text-white-100 [--faceStroke:var(--color-green-700)] [--offsetFill:var(--color-green-600)] [--offsetStroke:var(--color-green-700)]",
    },
    {
      color: "green",
      outlined: true,
      className:
        "bg-white-800 text-white-100 [--faceStroke:var(--color-green-600)] [--offsetFill:var(--color-green-700)] [--offsetStroke:var(--color-green-600)]",
    },
  ],
});

type Variants = VariantProps<typeof buttonStyles>;
export type ButtonVariants = Required<Omit<Variants, "disabled" | "font">> &
  Pick<Variants, "disabled" | "font">;
